import React, { useEffect, useState } from "react";
import { Col, Row } from "antd";
import {
  checkEmptyArray,
  checkEmptyObject,
  generateUUID,
  getWindowWidth,
  isMobileScreen,
  isObject
} from "../../../services";
import { getIconUrl } from "../../../services/asset";
import { MultiLevelSelector } from "../MultiLevelSelector";
import styles from "./style.scss";
import ReactGA from "react-ga4";

const MakeList = React.forwardRef((props: any, ref) => {
  const {
    child,
    dataSource,
    module,
    category,
    isSingleElement,
    isMultiRows,
    className,
    wrapClassName,
    showPlaceholder = false,
    showAllControls,
    setShowAllControls,
    maxChildren,
    isColumn,
    searchPage,
    hasAnyValue,
    getPopupContainer
  } = props;

  const [children, setChildren] = useState([]);
  const [childFields, setChildFields] = useState([]);

  const isMobile = isMobileScreen(getWindowWidth());

  useEffect(() => {
    const { isSingleElement, child, value, data } = props;
    if (
      checkEmptyArray(data && data[child && child.field]) ||
      checkEmptyArray(data && data[child && child.child.field])
    ) {
      loadChilds();
    } else {
      if (isSingleElement) {
        setChildren([{ id: generateUUID() }]);
      } else if (!checkEmptyObject(value)) {
        generateMinimumControls();
      } else {
        getChildFields(child);
      }
    }
  }, []);

  useEffect(() => {
    emitChangeValue();
  }, [JSON.stringify(children)]);

  const loadChilds = () => {
    const { data, child } = props;

    let localData = { ...data };

    let childs = [];

    if (localData && localData[child && child.child.field]) {
      localData &&
        localData[child && child.child.field].forEach(val => {
          childs.push({
            id: generateUUID(),
            value: { [child.child.field]: val }
          });
        });
    }

    if (localData && localData[child && child.field]) {
      localData &&
        localData[child && child.field].forEach(val => {
          childs.push({
            id: generateUUID(),
            value: { [child.field]: val }
          });
        });
    }

    setChildren(childs);
  };

  const generateMinimumControls = () => {
    const { minimum } = props;
    const childs = [];
    for (let i = 0; i < minimum; i += 1) {
      childs.push({ id: generateUUID() });
    }
    setChildren(childs);
  };

  const getChildFields = child => {
    const localChildFields = [];
    localChildFields.push(child.field);

    if (child.child) {
      getChildFields(child.child);
      setChildFields(localChildFields);
    }
  };

  const handleChildValueChange = (childValue, childKey) => {
    const child = children.find(c => c.id === childKey);
    child.value = childValue;
    emitChangeValue();
  };

  const handleAddChildClick = () => {
    ReactGA.event({
      category: "Pretraga",
      action: "Dodatna marka/model",
      label: "Dodatna marka/model"
    });
    if(!showAllControls || !searchPage || !isMobile) {
      setShowAllControls(true);
    }

    if (children.length == maxChildren) {
      return;
    }
    const localChildren = [...children];
    localChildren.push({ id: generateUUID() });

    setChildren(localChildren);
  };

  const handleRemoveChildClick = (childKey, childValue) => {
    const { minimum } = props;

    let newChildren = [];

    if (children.length === 1 && minimum > 0) {
      newChildren = [{ id: generateUUID() }];
    } else {
      newChildren = children.filter(c => c.id !== childKey);
    }
    
    setChildren(newChildren);
    emitChangeValue();
  };

  const emitChangeValue = () => {
    const { onChange } = props;
    const value: any = {};

    let tempChildren = JSON.parse(JSON.stringify(children));

    checkEmptyArray(tempChildren) &&
      tempChildren.forEach(makeData => {
        if (makeData && makeData.value && makeData.value["includeModelIds"]) {
          delete makeData.value["includeMakeIds"];
        }
      });

    tempChildren.forEach(c => {
      const childValue = c.value || c.singleValue;

      if (childValue) {
        isObject(childValue) &&
          Object.keys(childValue).forEach(key => {
            const index = childFields.indexOf(key);
            const childField = childFields[index + 1];

            if (!childValue[childField]) {
              const childId = childValue[key];

              if (value[key]) {
                if (!value[key].find(id => id === childId)) {
                  value[key].push(childId);
                }
              } else {
                value[key] = [childId];
              }
            }
          });
      }
    });

    onChange(checkEmptyObject(value));
  };

  return (
    <Row gutter={32}>
      <Col 
        md={(!showAllControls && !searchPage && !isMobile) && maxChildren > 1 ? 21 : 24}
        xs={24} 
      >
          {children
            .slice(...((showAllControls || searchPage || isMobile) ? [0, maxChildren] : [0, 1]))
            .map((c, index) => (
              <Row 
                className={(showAllControls || searchPage || isMobile) && maxChildren > 1 ? styles.row : styles.otherRow}
                gutter={8} 
                type="flex" 
                key={index}
                style={ (searchPage || isMobile) && index === children.length - 1 ? { paddingBottom: 10 } : {} }
              >
                <Col 
                  className={styles.col} 
                  key={index} 
                  md={showAllControls && maxChildren > 1 ? 12 : index == 0 ? 24 : 22}
                  xs={ index == 0 ? 24 : 22 }
                >
                  <MultiLevelSelector
                    child={child}
                    dataSource={dataSource}
                    module={module}
                    category={category}
                    value={c.value}
                    singleValue={c.value}
                    parentId={c.id}
                    onChange={handleChildValueChange}
                    selectorClassName={!isMultiRows ? null : styles.selector}
                    isMultiRows={isMultiRows}
                    className={!isMultiRows ? null : styles.multiRowSelector}
                    showAllLevel={true}
                    showPlaceholder={showPlaceholder}
                    isColumn={isColumn}
                    hasAnyValue={hasAnyValue}
                    getPopupContainer={getPopupContainer}
                  />

                  {(showAllControls || searchPage || isMobile) && children.length > 1 && index != 0 && (
                    <span
                      onClick={() => handleRemoveChildClick(c.id, c.value)}
                      className={showPlaceholder ? styles.removeRow : styles.removeRowPlaceholder}
                    >
                      <img
                        alt={"Više"}
                        src={getIconUrl("garbage.svg")}
                      />
                    </span>
                  )}
                  {showAllControls && !isMobile && children.length < maxChildren && children.length == (index + 1) && (
                    <span
                      onClick={handleAddChildClick}
                      className={showPlaceholder ? styles.addRowAbsolute : styles.addRowAbsolutePlaceholder}
                    >
                      <img
                        alt={"Dodajte još jedan"}
                        src={getIconUrl("circled-plus-red.svg")}
                      />
                      <span>{"Dodajte još jedan"}</span>
                    </span>
                  
                  )}
                </Col>
              </Row>
            ))}
            {(isMobile || (showAllControls && isMobile) || (!showAllControls && searchPage)) && children.length < maxChildren && (
              <Row>
                <Col
                  onClick={handleAddChildClick}
                  xs={24}
                  className={styles.addRow}
                >
                  <img
                    alt={"Dodajte još jedan"}
                    src={getIconUrl("circled-plus-red.svg")}
                  />
                  <span>{"Dodajte još jedan"}</span>
                </Col>
              </Row>
            )}
      </Col>
      {(!showAllControls && !searchPage && !isMobile) && maxChildren > 1 && (
        <Col
          onClick={handleAddChildClick}
          xs={24}
          md={2}
          className={styles.addRowSmall}
        >
          <img
            alt={"Dodajte još jedan"}
            src={getIconUrl("circled-plus-red.svg")}
          />
        {children.length > 1 && 
          <span>{children.length - 1}</span>
        }
                  
        </Col>
      )}
    </Row>
  );
});

MakeList.defaultProps = {
  title: "",
  isSingleElement: false,
  isMultiRows: false,
  onChange: () => null,
  className: "",
  minimum: 0,
  addMoreText: "Dodaj",
  addMoreIconName: "plus",
  wrapClassName: "",
  setShowAllControls: () => null,
};

export default MakeList;



// WEBPACK FOOTER //
// ./src/components/FormControls/MakeList/MakeList.tsx